module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-15.ab6e102d.png";